import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../Home/Home";
import About from "../About/About";
import Blogs from "../Blogs/Blogs";
import Blogdetail from "../Blogs/Blogdetail";
import Contactus from "../Contactus/Contactus";
import Profile from "../Myprofile/Profile";
import Editprofile from "../Myprofile/Editprofile";
import Changepassword from "../Myprofile/Changepassword";
import Myorders from "../Myprofile/Myorders";
import Myorderdetail from "../Myprofile/Myorderdetail";
import Review from "../Myprofile/Review";
import Myaddress from "../Myprofile/Myaddress";
import Addaddress from "../Myprofile/Addaddress";
import Editaddress from "../Myprofile/Editaddress";
import Login from "../Auth/Login";
import Signup from "../Auth/Signup";
import Forgorpassword from "../Auth/Forgorpassword";
import Otp from "../Auth/Otp";
import Createpassword from "../Auth/Createpassword";
import Shop from "../Shop/Shop";
import Shopdetail from "../Shop/Shopdetail";
import Cart from "../Cart/Cart";
import Wishlist from "../Cart/Wishlist";
import Checkout from "../Checkout/Checkout";
import Thankyou from "../Checkout/Thankyou";
import Termscondition from "../Termsandconditions/Termscondition";
import Privacypolicy from "../Termsandconditions/Privacypolicy";
import Shippingpolicy from "../Termsandconditions/Shippingpolicy";
import Deliverypage from "../Termsandconditions/Deliverypage";

function Publicroutes() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog-detail" element={<Blogdetail />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/my-profile" element={<Profile />} />
          <Route path="/edit-profile" element={<Editprofile />} />
          <Route path="/change-password" element={<Changepassword />} />
          <Route path="/my-orders" element={<Myorders />} />
          <Route path="/order-detail" element={<Myorderdetail />} />
          <Route path="/review" element={<Review />} />
          <Route path="/my-address" element={<Myaddress />} />
          <Route path="/add-address" element={<Addaddress />} />
          <Route path="/edit-address" element={<Editaddress />} />
          <Route path="/login" element={<Login />} />
          <Route path="/sign-up" element={<Signup />} />
          <Route path="/forgot-password" element={<Forgorpassword />} />
          <Route path="/otp" element={<Otp />} />
          <Route path="/create-password" element={<Createpassword />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop-detail" element={<Shopdetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/Thankyou" element={<Thankyou />} />
          <Route path="/terms-condition" element={<Termscondition />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
		  <Route path="/shipping-policy" element={<Shippingpolicy />} />
		  <Route path="/delivery-page" element={<Deliverypage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default Publicroutes;
